// total Inventory State

export default {
  totalInventoryList: [],
  totalInventoryInfo: {},
  inventoryInfo: {}
}
